<template>
  <v-container fluid class="integrately-container pa-0 ma-0">
    <!-- Modern Header Section -->
    <div
      v-if="showHeader"
      class="header-section mb-6"
      style="margin: 0 12px; position: relative;"
    >
      <v-btn icon small class="header-close-btn" @click="dismissHeader">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
      <div class="d-flex align-center mb-4">
        <div class="header-icon-wrapper mr-4">
          <v-icon size="32" color="#FFFFFF">mdi-connection</v-icon>
        </div>
        <div>
          <h1 class="page-title mb-1">Integrately</h1>
          <p class="page-subtitle mb-0">
            Connect GoDial with 1000+ apps at much cheaper costs
          </p>
        </div>
        <v-spacer></v-spacer>
        <div class="d-none d-sm-flex">
          <v-chip
            small
            class="mr-2"
            color="rgba(255,255,255,0.2)"
            text-color="white"
          >
            <v-icon small left>mdi-puzzle</v-icon>
            Automation
          </v-chip>
        </div>
      </div>
      <v-row class="feature-pills ma-0">
        <v-col cols="6" sm="3" class="pa-1">
          <div class="feature-pill">
            <v-icon small class="mr-2" color="white">mdi-apps</v-icon>
            <span>1000+ Apps</span>
          </div>
        </v-col>
        <v-col cols="6" sm="3" class="pa-1">
          <div class="feature-pill">
            <v-icon small class="mr-2" color="white">mdi-lightning-bolt</v-icon>
            <span>Quick Setup</span>
          </div>
        </v-col>
        <v-col cols="6" sm="3" class="pa-1">
          <div class="feature-pill">
            <v-icon small class="mr-2" color="white">mdi-cash</v-icon>
            <span>Cost Effective</span>
          </div>
        </v-col>
        <v-col cols="6" sm="3" class="pa-1">
          <div class="feature-pill">
            <v-icon small class="mr-2" color="white">mdi-robot</v-icon>
            <span>Automation</span>
          </div>
        </v-col>
      </v-row>
    </div>

    <!-- Content Section -->
    <div style="padding: 0 12px;">
      <v-card class="customBorderRadius elevation-2">
        <iframe
          frameborder="0"
          class="intframe"
          srcdoc="<script type='application/javascript'src='https://embed.integrately.com/embed?apps=Godial&limit=5&custom=true&strict=false'></script>"
        >
        </iframe>
      </v-card>
    </div>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      showHeader: false,
    };
  },
  created() {
    this.showHeader =
      localStorage.getItem("integratelyHeaderDismissed") !== "true";
  },
  methods: {
    dismissHeader() {
      this.showHeader = false;
      localStorage.setItem("integratelyHeaderDismissed", "true");
    },
  },
};
</script>

<style scoped>
.integrately-container {
  background-color: var(--v-background-base, #f5f5f5);
  min-height: 100vh;
}

.theme--dark .integrately-container {
  background-color: #121212 !important;
}

.feature-pills {
  margin-top: 16px;
}

.feature-pill {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 13px;
  font-weight: 500;
  height: 100%;
  transition: all 0.3s ease;
}

.feature-pill:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

.intframe {
  height: 100vh;
  width: 100%;
  border-radius: 12px;
}

/* Dark Theme Styles */
.theme--dark .customBorderRadius {
  background: #1e1e1e !important;
}

.theme--dark .header-section .page-title {
  color: white !important;
}

.theme--dark .header-section .page-subtitle {
  color: rgba(255, 255, 255, 0.95) !important;
}

.theme--dark .header-section .feature-pill {
  color: white !important;
}
</style>
